<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="config.dialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          {{config.title}}
        </v-card-title>

        <v-card-text>
          {{config.body}}
        </v-card-text>

        <v-divider></v-divider>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="config.dialog = false"
          >
            {{config.footer}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    props:['config', 'bgcolorx'],
    data () {
      return {
        dialog: false
      }
    }
  }
</script>